import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/LegalPages.css';

const MentionsLegales = () => {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="back-link">
          ← {t('legal.backHome') || 'Retour à l\'accueil'}
        </Link>

        <h1 className="legal-title">
          {t('legal.mentions.title') || 'Mentions Légales'}
        </h1>

        <div className="legal-content">
          {/* Éditeur du site */}
          <section className="legal-section">
            <h2>{t('legal.mentions.editor') || 'Éditeur du site'}</h2>
            <p>
              <strong>Nom :</strong> Ibrahim Zaougui<br />
              <strong>Statut :</strong> Auto-entrepreneur / Micro-entreprise<br />
              <strong>SIRET :</strong> 92463296100018 <br />
              <strong>Adresse :</strong> 710 Routes de Frans - Villefranche sur Saône <br />
              <strong>Email :</strong> <a href="mailto:contact@dreamdev.fr">contact@dreamdev.fr</a><br />
            </p>
          </section>

          {/* Directeur de publication */}
          <section className="legal-section">
            <h2>{t('legal.mentions.director') || 'Directeur de la publication'}</h2>
            <p>
              Le directeur de la publication du site est : Zaougui Ibrahim
            </p>
          </section>

          {/* Hébergement */}
          <section className="legal-section">
            <h2>{t('legal.mentions.hosting') || 'Hébergement'}</h2>
            <p>
              <strong>Hébergeur :</strong> OVH<br />
              <strong>Adresse :</strong> 2, rue Kellermann, 59100 Roubaix.<br />
              <strong>Site web :</strong> <a href="https://www.ovhcloud.com/fr/" target="_blank" rel="noopener noreferrer">OVH</a>
            </p>
            <p className="legal-note">
              Le site est hébergé sur les serveurs de OVH, situés en France.
            </p>
          </section>

          {/* Propriété intellectuelle */}
          <section className="legal-section">
            <h2>{t('legal.mentions.intellectual') || 'Propriété intellectuelle'}</h2>
            <p>
              L'ensemble du contenu de ce site (textes, images, vidéos, logos, icônes, etc.) est la propriété exclusive d'Ibrahim Zaougui ou de ses partenaires.
            </p>
            <p>
              Toute reproduction, distribution, modification, adaptation, retransmission ou publication de ces différents éléments est strictement interdite sans l'accord écrit d'Ibrahim Zaougui.
            </p>
            <p>
              Le non-respect de cette interdiction constitue une contrefaçon susceptible d'engager la responsabilité civile et pénale du contrefacteur.
            </p>
          </section>

          {/* Données personnelles */}
          <section className="legal-section">
            <h2>{t('legal.mentions.data') || 'Données personnelles'}</h2>
            <p>
              Le site collecte des données personnelles uniquement via les formulaires de contact. Pour plus d'informations sur la collecte et le traitement de vos données, consultez notre{' '}
              <Link to="/politique-confidentialite" className="legal-link">
                Politique de confidentialité
              </Link>.
            </p>
            <p>
              Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données vous concernant. Pour exercer ces droits, contactez-nous à : <a href="mailto:contact@dreamdev.fr">contact@dreamdev.fr</a>
            </p>
          </section>

          {/* Cookies */}
          <section className="legal-section">
            <h2>{t('legal.mentions.cookies') || 'Cookies'}</h2>
            <p>
              Le site utilise des cookies pour améliorer l'expérience utilisateur et analyser le trafic. Vous pouvez gérer vos préférences de cookies via la bannière affichée lors de votre première visite.
            </p>
            <p>
              Les cookies strictement nécessaires au fonctionnement du site (authentification, préférences de langue) ne peuvent pas être désactivés.
            </p>
          </section>

          {/* Limitations de responsabilité */}
          <section className="legal-section">
            <h2>{t('legal.mentions.liability') || 'Limitations de responsabilité'}</h2>
            <p>
              Ibrahim Zaougui s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, Ibrahim Zaougui ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition.
            </p>
            <p>
              En conséquence, Ibrahim Zaougui décline toute responsabilité :
            </p>
            <ul>
              <li>Pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur le site</li>
              <li>Pour tous dommages résultant d'une intrusion frauduleuse d'un tiers ayant entraîné une modification des informations</li>
              <li>Pour tous dommages directs ou indirects résultant de l'utilisation du site</li>
            </ul>
          </section>

          {/* Liens hypertextes */}
          <section className="legal-section">
            <h2>{t('legal.mentions.links') || 'Liens hypertextes'}</h2>
            <p>
              Le site peut contenir des liens hypertextes vers d'autres sites. Ibrahim Zaougui n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
            </p>
            <p>
              La création de liens hypertextes vers ce site nécessite l'autorisation préalable de Ibrahim Zaougui.
            </p>
          </section>

          {/* Droit applicable */}
          <section className="legal-section">
            <h2>{t('legal.mentions.law') || 'Droit applicable et juridiction'}</h2>
            <p>
              Les présentes mentions légales sont régies par le droit français. En cas de litige et à défaut d'accord amiable, le litige sera porté devant les tribunaux français compétents.
            </p>
          </section>

          {/* Date de mise à jour */}
          <section className="legal-section">
            <p className="legal-update">
              <strong>{t('legal.lastUpdate') || 'Dernière mise à jour'} :</strong> {new Date().toLocaleDateString('fr-FR')}
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;